module.exports = __webpack_public_path__ + "afbc8674910a45e840bd9758914aefe3.png";